import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import SelectSearch, { OptionItem } from "src/components/SelectSearch";
import { FormLabel } from "src/components/atoms/FormLabel";
import { InputRow } from "../styles";
import { CustomWorkRequestDropdownProps, WorkRequestDropdown } from "../types";

export const CustomWorkRequestDropdown = ({ customField }: CustomWorkRequestDropdownProps) => {
  const { control } = useFormContext();

  const prepareDropDownValues = (): OptionItem[] =>
    (customField.dropdown as WorkRequestDropdown).options.map((option) => ({
      id: option.value,
      value: option.label,
    })) ?? [];

  return (
    <InputRow>
      <FormLabel htmlFor={customField.id} required={customField.rules?.required}>
        {customField.label}
      </FormLabel>
      <Controller
        control={control}
        name={customField.id}
        rules={customField.rules}
        defaultValue={customField.defaultValue}
        render={({ field: { name, value, onChange, ref }, fieldState: { error } }) => (
          <SelectSearch
            id={customField.id}
            options={prepareDropDownValues()}
            defaultValue={value}
            placeholder={customField.dropdown?.placeholder ?? ""}
            name={name}
            onChange={(option) => onChange(option.id)}
            ref={ref}
            error={error}
          />
        )}
      />
    </InputRow>
  );
};
